module.exports = __webpack_public_path__ + "img/stub-espn-topbar--xl.611967f6.jpg";